export async function sendCommandFlex35(descricao, action) {
  console.log(`Comando enviado da lâmpada de ID ${descricao} com a ação ${action}`);

  const url = `${process.env.REACT_APP_SERVER_IP}/ComandoFlex35`;
  const payload = {
      buttonId: descricao,
      action: action
  };

  try {
      const response = await fetch(url, {
          method: "POST",
          headers: {
              "Content-Type": "application/json"
          },
          body: JSON.stringify(payload)
      });

      if (response.ok) {
          console.log("Comando enviado com sucesso.");
      } else {
          console.error("Erro ao enviar o comando.");
      }
  } catch (error) {
      console.error("Erro ao enviar o comando:", error);
  }
}